import * as THREE from "three";

export const MENU_GLOW_CLOSE_GRADIENT =
  "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7) 20%, rgba(255,255,255,0.3) 45%, transparent 65%)";

export const MENU_GLOW_GRADIENTS_DARK: string[] = [
  "radial-gradient(circle, rgba(255,147,41,1) 0%, rgba(255,147,41,0.7) 20%, rgba(255,147,41,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(255,180,107,1) 0%, rgba(255,180,107,0.7) 20%, rgba(255,180,107,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(255,197,143,1) 0%, rgba(255,197,143,0.7) 20%, rgba(255,197,143,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(255,219,186,1) 0%, rgba(255,219,186,0.7) 20%, rgba(255,219,186,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(228,232,240,1) 0%, rgba(228,232,240,0.7) 20%, rgba(228,232,240,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(213,225,243,1) 0%, rgba(213,225,243,0.7) 20%, rgba(213,225,243,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(255,147,41,1) 0%, rgba(255,147,41,0.7) 20%, rgba(255,147,41,0.3) 45%, transparent 70%)",
];

export const MENU_GLOW_GRADIENTS_LIGHT: string[] = [
  "radial-gradient(circle, rgba(255,120,20,1) 0%, rgba(255,120,20,0.75) 20%, rgba(255,120,20,0.35) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(255,150,60,1) 0%, rgba(255,150,60,0.75) 20%, rgba(255,150,60,0.35) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(230,130,55,1) 0%, rgba(230,130,55,0.7) 20%, rgba(230,130,55,0.32) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(140,110,90,1) 0%, rgba(140,110,90,0.7) 20%, rgba(140,110,90,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(90,95,110,1) 0%, rgba(90,95,110,0.7) 20%, rgba(90,95,110,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(120,115,135,1) 0%, rgba(120,115,135,0.7) 20%, rgba(120,115,135,0.3) 45%, transparent 70%)",
  "radial-gradient(circle, rgba(255,120,20,1) 0%, rgba(255,120,20,0.75) 20%, rgba(255,120,20,0.35) 45%, transparent 70%)",
];

export const KELVIN_STROKE_COLORS: string[] = [
  "hsl(30, 100%, 50%)",
  "hsl(35, 80%, 60%)",
  "hsl(38, 60%, 70%)",
  "hsl(42, 30%, 80%)",
  "hsl(210, 15%, 85%)",
  "hsl(215, 25%, 90%)",
  "hsl(30, 100%, 50%)",
];

export const KELVIN_HSL_STOPS: { h: number; s: number; l: number }[] = [
  { h: 30, s: 100, l: 50 },
  { h: 35, s: 80, l: 60 },
  { h: 38, s: 60, l: 70 },
  { h: 42, s: 30, l: 80 },
  { h: 210, s: 15, l: 85 },
  { h: 215, s: 25, l: 90 },
];

export const MENU_GLOW_PULSE_TRANSITION = {
  duration: 60,
  repeat: Infinity,
  ease: "linear",
  opacity: { duration: 6, repeat: Infinity, ease: "easeInOut" },
  scale: { duration: 6, repeat: Infinity, ease: "easeInOut" },
} as const;

export const sampleKelvinColor = (t: number, target: THREE.Color) => {
  const f = ((t % 1) + 1) % 1;
  const scaled = f * KELVIN_HSL_STOPS.length;
  const i = Math.floor(scaled);
  const k = scaled - i;
  const a = KELVIN_HSL_STOPS[i];
  const b = KELVIN_HSL_STOPS[(i + 1) % KELVIN_HSL_STOPS.length];
  let dh = b.h - a.h;
  if (dh > 180) dh -= 360;
  if (dh < -180) dh += 360;
  const h = (a.h + dh * k + 360) % 360;
  const s = a.s + (b.s - a.s) * k;
  const l = a.l + (b.l - a.l) * k;
  target.setHSL(h / 360, s / 100, l / 100);
  return target;
};
